export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// /Users/sharvil/Desktop/fall17/adaptive/assign1/~/d3-force/src/constant.js
// module id = ../../../../d3-force/src/constant.js
// module chunks = 3